export const TEST_ID = 'selectMenu';

export const DEFAULT_PLACEHOLDER = 'Select an option';
